module.exports = __webpack_public_path__ + "static/media/header-icon.ec393960.svg";